'use client';
import { OneTrustScripts } from '@ecom/storefront-consent/one-trust-scripts';
import { useAppStore } from '@/features/shared/app-store';

export default function WtOneTrustScripts() {
  const setConsent = useAppStore((state) => state.consentActions.setConsent);

  return (
    <OneTrustScripts
      websiteId={process.env.NEXT_PUBLIC_CONSENT_WEBSITE_ID}
      onConsentChanged={setConsent}
    />
  );
}
